import * as TYPES from '@app/store/actionTypes';
import { TemplateAction, templateDataFetched } from '@app/store/template/actions';

type TemplateIdState = string;

const initialState: TemplateIdState = '';

export default function reducer(state: TemplateIdState = initialState, action: TemplateAction) {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
      return initialState;
    case templateDataFetched.type:
      return action.payload.id;
    default:
      return state;
  }
}
